// working maintenance


import React, { useEffect, useRef, useState } from 'react';
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';




const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));
const CustomerDevices = ()=>{
    const navigate = useNavigate();
    let uid = localStorage.getItem("user_id");
    let user_type = localStorage.getItem("user_type");
    const classes = useStyles();
    const handleDevice = ()=>{
        navigate('/maintenance7');

    }
    const handleGoDevice = ()=>{
        if(user_type == 7){
        navigate('/go-customer?dist='+uid);
    }else{
        navigate('/go-customer');
    }

    }
    const handleDevice6 = ()=>{
        if(user_type==7){
            navigate('/device6-customer?dist='+uid);

        }else{
            navigate('/device6-customer');

        }

    }
    const handleDevice5 = ()=>{
        if(user_type==7){
        navigate('/device5-customer?dist='+uid);
    }else{
            navigate('/device5-customer');

        }

    }
    const handleDeviceAll = ()=>{
       navigate('/device-all-customer');

    }

    return(
        <div className="">
            <div className="cmail">
                <Top />
            </div>
            <div className="wrp-dashbord">
                <div className="cemail-left">
                    <Leftsiderbar />
                </div>
                <div className="right-section">
                    <div className="add-btn-wrp add-btn-wrp2">
                        <div className='button-div'>
                        <button className='create-button' onClick={handleGoDevice}>Device GO</button>
                        <button className='create-button' onClick={handleDevice6}>Device 6.0</button>
                        <button className='create-button' onClick={handleDevice5}>Device 5.0</button>
                        <button className='create-button' onClick={handleDeviceAll}>All Device</button>
                        </div>    
                    </div>
                </div>
            </div>
          

        </div>
    )
}
export default CustomerDevices;